export default {
  // Login
  Username: 'Nome do utilizador',
  Password: 'Senha',
  'Logging in, please wait': 'Iniciando a sessão, por favor, aguarde',
  'Log in': 'Iniciar sessão',
  'Log in with single sign-on': 'Iniciar a sessão num único clique',
  'You are being safely logged out, please wait': ' O sistema está a ser desligado em segurança, por favor, aguarde ',
  Back: 'Voltar atrás',

  // Sidebar
  Department: 'Departamento',
  'Log out': 'Sair',
  'Your citizens': 'Os seus utentes',
  'Edit information': 'Editar informação',
  'Lock screen': 'Ecrã bloqueado',
  'Add new task': 'Adicionar nova tarefa',

  // Group list
  'Select a group': 'Selecionar um grupo',

  // Member list
  'No name': 'Sem nome',

  // Member show
  Day: 'Dia',
  Week: 'Semana',
  'Time frame': 'Período de tempo',
  'No click in time frame': 'Cronómetro atrasado',
  'Overdue timer': 'Cronómetro atrasado',
  'Click in time frame': 'Clique no período de tempo',
  'Click outside time frame': 'Clique fora do horário indicado',
  'Approved deviation': 'Desvio aprovado',
  'This citizen has no tasks': ' Este utente não tem tarefas',
  'Hide deviations': 'Ocultar desvios',
  'Show deviations': 'Mostrar desvios',
  'Show week': 'Mostrar semana',
  'Show today': 'Mostrar hoje',
  'Approving deviation': 'Aprovando o desvio',
  'Approving deviation with note': 'Aprovando o desvio com nota',
  'Deviation approved': 'Desvio aprovado',
  'Deviation approved with note': 'Desvio aprovado com nota',
  'Approve deviation': 'Aprovar desvio',
  'Note (optional)': 'Nota (opcional)',
  'Optional text': 'Texto opcional',
  Calendar: 'Calendário',
  Appearance: 'Aparência',
  Full: 'Completo',
  Compact: 'Compactar',

  // Member Edit
  'First name': 'Primeiro Nome',
  'Last name': 'Último nome',
  'Save changes': 'Guardar alterações',

  // Deviation info
  Approving: 'A aprovar',
  Cancel: 'Cancelar',
  Confirm: 'Confirmar',
  Approve: 'Aprovar',
  'X deviations in total': '{count} desvios no total',

  // Task create
  Timer: 'Cronómetro',
  Schedule: 'Cronograma',
  'On demand': 'A aguardar pedido',
  Braden: 'Escala Braden',
  minute: 'minuto',
  minutes: 'minutos',
  hour: 'hora',
  hours: 'horas',
  'MAC address already in use': 'Endereço MAC já em uso',
  'Button ID not found': 'Botão ID não encontrado',
  'Delete task': 'Apagar tarefa',
  'This cannot be reverted': 'Esta ação não poderá ser revertida',
  Delete: 'Apagar',
  Edit: 'Editar',
  'Edit task': 'Editar tarefa',
  'Create new task': 'Criar nova tarefa',
  Name: 'Nome',
  Buttons: 'Botões',
  Type: 'Tipo',
  Time: 'Tempo',
  'Give the task a name': 'Dê um nome à tarefa',
  Continue: 'Continuar',
  'Enter button ID': 'Pressionar botão ID',
  'Enter MAC address': 'Digite o endereço MAC',
  'Use MAC address': 'Use o endereço MAC',
  'Use button ID': 'Use o botão ID',
  'Add button': 'Acrescente o botão',
  'Select a type': 'Selecione um tipo',
  Ok: 'Ok',
  Close: 'Fechar',
  'Select time': 'Selecionar tempo',
  Occurrence: 'Ocorrência',
  'Every day': 'Todos os dias',
  'Specific weekdays': 'Dias da semana específicos',
  'Add time': 'Acrescentar tempo',
  'Time tolerance in minutes': 'Tempo de tolerância em minutos',
  'On demand requires no planning': 'A pedido não requer planeamento',
  'How much time should pass between each click': 'Quanto tempo deve passar entre cada clique',
  'When should the timer start': 'Quando deve começar o cronómetro',
  Now: 'Agora',
  'Set a time': 'Estabeleça o tempo',
  'Enter Braden Score': 'Inserir a pontuação Braden',
  'Add task': 'Adicionar tarefa',
  Remove: 'Remover',
  'Select days': 'Selecione os dias',
  'Times can not overlap': 'Os tempos não podem se sobrepor',
  Monday: 'Segunda-feira',
  Tuesday: 'Terça-feira',
  Wednesday: 'Quarta-feira',
  Thursday: 'Quinta-feira',
  Friday: 'Sexta-feira',
  Saturday: 'Sábado',
  Sunday: 'Domigo',
  'Task added': 'Tarefa adicionada',
  'Task updated': 'Tarefa atualizada',
  'Task deleted': 'Tarefa excluída',
  'Changes saved': 'Alterações salvas',
  'Allow clicks outside of schedule?': 'Permitir cliques fora da programação?',
  'Confirm time tolerance': 'Confirme a tolerância de tempo',
  'Is the current time tolerance of X minutes correct?': 'A tolerância de tempo atual de {time} minutos está correta?',

  // Locked screen: Ecrã bloqueado
  'You should complete the task {{task}} in {{time}}': 'Deverá {{task}} às {{time}}',
  'You should complete the task {{task}} within {{time}}': 'Deverá {{task}} dentro de {{time}}',
  'You should complete the task {{task}} now': 'Deverá {{task}} agora',
  'The task {{task}} is overdue by {{time}}, complete as soon as possible': 'Não concluiu a tarefa: {{task}} que deveria ter sido realizada às {{time}}, realize-a assim que possível',
  'Remember to complete the task {{task}} in {{time}}': 'Lembre-se de {{task}} às {{time}}',

  'Citizen-screen': 'Ecrã do utente',
  'Add new Citizen': 'Acrescentar novo utente',
  'Or choose Citizen from list': 'Ou escolher utente da lista',
  'It is time to': 'É hora de',
  'Nothing to do - Good job!': 'Nada a fazer – Bom trabalho!',
  'Within the next minutes you need to remember {{task}} it would be best to do at {{time}}': 'Dentro dos próximos minutos deverá: {{task}}!. O melhor horário para realizar esta tarefa é: {{time}}!',
  "It's time to {{task}}": 'É hora de {{task}}',
  Version: 'Versão',
  'Sharing of your location is needed to use the app correctly': 'A partilha da sua localização é necessária para utilizar a aplicação corretamente',

  // MarkerInfoModal
  Fulfilled: 'Realizado',
  Deviation: 'Desvio',
  'Approved by': 'Aprovado por',
  'Note by': 'Nota de',
  'Add note': 'Adicionar nota',
  Note: 'Nota',
  'Adding note': 'Adicionando nota',
  'Sort by deviations': 'Ordenar por desvios',
  'Sort by name': 'Ordenar por nome',
  Sort: 'Ordenar',
  'Your active citizens': 'Seus cidadãos ativos',
  'Your inactive citizens': 'Seus cidadãos inativos',
};
